// @flow

import React from "react";
import type {Product} from "../../models/Product";
import {currencyConverter} from "../../helper/currency";
import history from "../../history";
import {Link} from "react-router-dom";
import type {translate} from "../../i18next";
import "./WishlistPage.scss";
import {withTranslation} from "react-i18next";

export type WishlistItemProps = {
    t: translate,
    product: Product,
    removeProduct: () => void
}

const WishlistItem = (props: WishlistItemProps) => {
    const {product} = props;
    const detailPageUrl = history.getProductUrl(product.id, product.name);

    return (
        <div className="hpm-wishlistItem">
            <div className="hpm-productItem">
                <Link className="hpm-productItemImagebox" to={detailPageUrl}>
                    <img
                        src={product.galleryImage.previewImage ? product.galleryImage.previewImage.attachmentUrl : product.galleryImage.attachmentUrl}
                        alt={product.galleryImage.caption || product.name}/>
                </Link>

                <div className="hpm-productItemTextbox">
                    <Link to={detailPageUrl}>
                        {product.name}
                    </Link>
                    <div>
                        {product.price && (
                            <div className="price-container">
                                <div className="price">
									<span className="bookmark-price">
										{currencyConverter(product.price)}
									</span>
                                </div>
                                {product.unitPrice && (
                                    <div className="unit-price">
                                        <small>({currencyConverter(product.unitPrice.pricePerUnit)} / {product.unitPrice.measuringUnit === "sqm" ? "m²" : product.unitPrice.measuringUnit === "cbm" ? "m³"
                                            : product.unitPrice.measuringUnit})
                                        </small>
                                    </div>
                                )}
                                <small>
									<span className="hpm-productItemPriceNotice">
										{product.price && " " + props.t("productDetail.inclVAT")}
									</span>
                                </small>
                            </div>
                        )}
                    </div>
                    <div className={"hpm-sideBarArticleNumber"}>
						<span className={"hpm-ArticleNumberLabel"}>
							{props.t("productDetail.articleNumber") + ": "}
						</span>
                        <span className={"hpm-ArticleNumberValue"}>
							{product.articleNumber}
						</span>
                    </div>
                </div>
            </div>
            <div className="hpm-itemButtonbox hpm-noPrint">
                <button aria-label={props.t("productDetail.removeFromBookmarks")} type={"button"}
                        onClick={() => props.removeProduct(product)} className="hpm-delete"/>
            </div>
        </div>
    );
};

export default withTranslation()(WishlistItem);
